// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';

import { getOrders, getLoading, getError } from '../store/selectors';
import * as ordersActions from '../store/actions';
import { OrderLite, Description, Loader } from '../../../../../../../components';
import styles from './styles';
import ArrangeCollection from '../components/ArrangeCollection/ArrangeCollection';

class MyOrders extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    requestOrders: PropTypes.func,
    orders: PropTypes.any,
    loading: PropTypes.bool,
    resetOrders: PropTypes.func,
    error: PropTypes.string,
  };

  static defaultProps = {
    classes: {},
    requestOrders: () => { },
    resetOrders: () => { },
    orders: [],
    loading: false,
    error: null,
  };

  componentDidMount() {
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('loggedID');
    this.props.requestOrders({ token, id });
  }

  componentWillUnmount() {
    this.props.resetOrders();
  }

  renderOrders = () => {
    return (
      this.props.orders.map(el => (
        <OrderLite key={el.OrderID} order={el} />))
    );
  }

  renderError = () => {
    const { classes, error } = this.props;
    return (<span className={classes.text}>{error}</span>);
  }

  renderNoOrders = () => {
    const { classes } = this.props;
    return (<span className={classes.text}>{'You don\'t have orders yet'}</span>);
  }

  renderTextInfo = () => {
    const { orders, loading, error } = this.props;
    if (!loading) {
      if (error) {
        return this.renderError();
      }
      if (orders.length === 0) {
        return this.renderNoOrders();
      }
    }
    return null;
  }

  render() {
    const { classes, orders } = this.props;
    const isBookshop = parseInt(localStorage.getItem('isBookshop'), 10);
    return (
      <div className={classes.root}>
        <MediaQuery maxWidth={549}>
          <Description text={'My orders'} />
        </MediaQuery>
        {this.renderTextInfo()}
        {this.props.loading ? <Loader /> : (
          <div className={classes.container}>
            { orders.length !== 0 && isBookshop ? <ArrangeCollection /> : null}
            {this.renderOrders()}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orders: getOrders(state),
    loading: getLoading(state),
    error: getError(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestOrders: id => dispatch(ordersActions.requestOrders(id)),
    resetOrders: () => dispatch(ordersActions.resetOrders()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MyOrders));
